import { ApiClient } from '../http/api_client';

export class Dummy {
  constructor(private value: string) {
    this.value = value;
  }
  getMessage(id: string) {
    return `${this.value}${id}`;
  }
}

export class ItemRepository {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  async getItemAttribute(catalogItemCode: string) {
    return ApiClient.get(`/itemAttribute/${catalogItemCode}/`, {responseType: 'document'});
  }

  getMessage(id: string) {
    return new Dummy('test').getMessage(id);
  }

  // 以降のAPI callは、WebサーバContorollerをAPIとして非同期に呼び出して確認していたものであり、
  // 方針としては、ajaxで呼ぶAPIは外部APIとして別のリポジトリに立てる。

  putTest() {
    ApiClient.put('/api/sample/1', { quantity: 1 }, (error) => {
      if (error) {
        console.log('put test is error.');
      }
    });
  }

  getTest() {
    return ApiClient.get('/api/sample/1');
  }

  postTest() {
    return ApiClient.post('/api/sample', { quantity: 2 });
  }

  deleteTest() {
    ApiClient.delete('/api/sample/1');
  }

  getErrorTest() {
    return ApiClient.get('/api/sample/error/1');
  }
}
